/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @format
 * @flow
 */

import React from 'react';
import cn from 'classnames';
import { Box, Grid } from '@material-ui/core';
import useStyles from './useStyles';

const TableOrientation = ({ tableOrientation, onChooseOrientation, selectedTableShape }) => {
  const classes = useStyles();
  return (
    <Grid container className={cn(classes.gridContainer)}>
      {tableOrientation.map(image =>
        <Grid item key={`key-${image.value}`} xs={6} sm={4} md={3} lg={2}>
          <Box
            m={0.5}
            p={0.5}
            onClick={() => onChooseOrientation(image)}
            className={cn(
              classes.gridBox,
              { [classes.selectedTool]: selectedTableShape?.value === image?.value }
            )}
          >
            <img src={image.icon} className={classes.imgs} alt={'Img'} />
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default TableOrientation;
